<template>
    <yxt-drawer size="960px" :title="''" :visible.sync="stateInner.dialogVisible"
      ref="selector"
      :append-to-body="true"
      :modal-append-to-body="true"
      :destroy-on-close="true"
      :before-close="close">
      <yxt-user-selector
        :functionCode="functionCode" :dataPermissionCode="dataPermissionCode"
        class=""
        ref="userselector"
        :data="states.users"
        :tabs="states.tabs"
      ></yxt-user-selector>
      <span slot="footer" class="dialog-footer">
        <yxt-button plain @click="close()">{{ $t('pc_biz_ote_btn_cancle') }}</yxt-button>
        <yxt-button type="primary" @click="getUsers">{{ $t('pc_biz_ote_btn_confirm') }}</yxt-button>
      </span>
    </yxt-drawer>
</template>
<script>
import UserSelector from 'yxt-biz-pc/packages/user-selector';
import {
  Drawer
} from 'yxt-pc';
export default {
  name: 'selectUsers',
  components: {
    YxtUserSelector: UserSelector,
    YxtDrawer: Drawer
  },
  props: {
    states: {
      type: Object
    },
    functionCode: {
      type: String,
      default: ''
    },
    dataPermissionCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      stateInner: {
        dialogVisible: false
      }
    };
  },
  mounted() {
    // 让初次加载的时候drawer不弹出，等待drawer组件加载后再弹出。避免遮罩和弹窗内容的dom位置层级问题
    this.stateInner = this.states;
  },
  methods: {
    getUsers() {
      this.$refs.userselector.getSelected().then(result => {
        if (result.length === 0) {
          this.$message({
            type: 'warning',
            message: this.$t('pc_biz_ote_msg_userselectnotnull')
          });
          return;
        }
        this.$emit('selectUsersCallback', result);
        this.states.dialogVisible = false;
      }).catch(e => {
        console.log(e);
      });
    },
    close(done) {
      if (done) {
        done();
      } else {
        this.$refs.selector.closeDrawer();
      }
      this.$emit('closeSelectDrawer');
    }
  }
};
</script>
